"use client";

import { Core } from "@faire/slate/foundation/color";
import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import { iconCls } from "@faire/slate/lib/tracking";
import React from "react";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1583))
 * @trackcomponent
 * @lastsynced 2025-07-07T19:23:54.936Z
 * @optimized using svgo:^3.0.2
 */
export const EyeOpen = createSVGIcon(
  <>
    <path
      d="M22.687 10.858a1.656 1.656 0 0 1 0 2.284C20.88 15.086 16.776 18.857 12 18.857s-8.88-3.771-10.687-5.715a1.656 1.656 0 0 1 0-2.284C3.12 8.914 7.224 5.143 12 5.143s8.88 3.771 10.687 5.715Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.572 12a3.428 3.428 0 1 0 6.856 0 3.428 3.428 0 0 0-6.856 0Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "EyeOpen",
  {
    className: iconCls(),
    color: Core.icon.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
